import env from '@/libs/env'

export default {
  type: 'Loại',
  code: 'Mã',
  typePlaceholder: 'Chọn loại',
  codePlaceholder: 'Nhập mã',
  AIRPORT: 'Sân bay',
  CARRIER: 'Hãng bay',
  CITY: 'Thành phố',
  COUNTRY: 'Quốc gia',
  EQUIPMENT: 'Loại tàu bay',
  TIMESTAMP: 'TIMESTAMP',
  result: 'Kết quả',
  noResult: 'Không tìm thấy kết quả',
  cityCode: 'Mã thành phố',
  countryCode: 'Mã quốc gia',
  name: 'Tên',

  currencyConversion: 'Chuyển đổi ngoại tệ',
  amount: 'Số tiền',
  amountPlaceHolder: 'Nhập Số tiền',
  from: 'Từ',
  to: 'Thành',
  convert: 'Chuyển đổi',
  bankSellingRate: 'Tỷ giá',
  convertedAmount: 'Số tiền sau chuyển đổi',
  description: 'Mô tả',

  flightsSchedule: {
    title: 'Bảng điện tử',
    columns: {
      scheduleTime: 'Kế hoạch',
      estimateTime: 'Dự kiến',
      airportNameA: 'Đến từ',
      airportNameD: 'Điểm đến',
      airlineName: 'Hãng hàng không',
      flightNumber: 'Chuyến bay',
      gateA: 'Đảo hành lý',
      gateD: env.isColoringTableFlightsSchedule ? 'Cửa' : 'Cửa khởi hành',
      terminal: 'Nhà ga',
      checkinRow: 'Quầy check-in',
      remark: 'Ghi chú',
    },
    filters: {
      stationType: 'Chuyến bay',
      tripType: 'Chuyến đi/đến',
      departure: 'Địa điểm',
      departureDate: 'Ngày',
      departureHour: 'Giờ',
    },
    stationType: {
      DOM: 'Quốc nội',
      INT: 'Quốc tế',
    },
    tripType: {
      Arrival: 'Chuyến đến',
      Departure: 'Chuyến đi',
    },
    airport: {
      HAN: 'Hà Nội',
      SGN: 'Hồ Chí Minh',
      DAD: 'Đà Nẵng',
      CXR: 'Nha Trang',
    },
    msg: {
      errorFetching: 'Lỗi tải dữ liệu',
    },
  },
}
